import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { ToastStatus } from '../../constants/toastMessage.constants';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { LabelCreateModel, LabelModel } from '../../models/label.model';

// constants
import API from '../../services/api';
import { toastService } from '../../services/toast.service';

import formulaKeys from '../formulas/_queryKeys';
// hooks
import useAnalytics from '../helper/useAnalytics';
import labelKeys from './_queryKeys';

export default function useLabelCreateMutation(
    variantType?: string,
    formulaId?: number,
    variantId?: string,
) {
    const queryClient = useQueryClient();

    const { track } = useAnalytics();

    return useMutation<AxiosResponse<LabelModel>, BaseError, LabelCreateModel>({
        mutationFn: API.createLabel,
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries({ queryKey: labelKeys.all() });
            queryClient.invalidateQueries({
                queryKey: ['alternates', formulaId, variantId],
            });
            queryClient.invalidateQueries({ queryKey: labelKeys.labelCount() });
            track('personalization_label_created', {
                variant_type: variantType,
            });
            queryClient.invalidateQueries({
                queryKey: [
                    ...formulaKeys.formulaLabelAlternateCount(formulaId!),
                ],
            });
            variantType &&
                queryClient.invalidateQueries({
                    queryKey: labelKeys.labelsByVariant(variantType),
                });
            toastService.showNotificationToast(
                ToastStatus.Success,
                `Label ${data.label_name} created successfully`,
            );
        },
        onError: ({ message }) => {
            toastService.showNotificationToast(ToastStatus.Error, message);
        },
    });
}
